module.exports = __webpack_public_path__ + "static/media/hannah_german_austerian.a58dfe03.mp3";